__turbopack_context__.v({
  "helios-program-cost": "_99RUuW_helios-program-cost",
  "helios-program-cost__body": "_99RUuW_helios-program-cost__body",
  "helios-program-cost__fineprint": "_99RUuW_helios-program-cost__fineprint",
  "helios-program-cost__label": "_99RUuW_helios-program-cost__label",
  "helios-program-cost__row": "_99RUuW_helios-program-cost__row",
  "helios-program-cost__summary": "_99RUuW_helios-program-cost__summary",
  "helios-program-cost__table": "_99RUuW_helios-program-cost__table",
  "helios-program-cost__value": "_99RUuW_helios-program-cost__value",
});
